import React, { useEffect } from "react";

function BeforeUnLoad({ state }) {
  useEffect(() => {
    localStorage.setItem("dirty", state);

    window.onbeforeunload = (event) => {
      const e = event || window.event;

      if (!!state) {
        e.preventDefault();
        if (e) {
          e.returnValue = ""; // Legacy method for cross browser support
        }
        return ""; // Legacy method for cross browser support
      }
    };
  }, [state]);

  return <div></div>;
}

export default BeforeUnLoad;
